import {TrackEvent} from "@next/eventservice"

const TrackingEvent = new TrackEvent()

export const publishTrackingEvent = (eventName: string, data: any) => {
    TrackingEvent.publish({event: eventName, data})
}
